
// Module
import routes from './routes';

export default angular.module('app.main.outsideApp.module', [])
	.config(routes)
	.name


/** WEBPACK FOOTER **
 ** ./src/main/outsideApp/index.js
 **/